export default __webpack_public_path__ + "static/media/separacao_marker.fadb127a.svg";